var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '페이지소개'
    }
  }), _c('div', {
    staticClass: "contents pb-none"
  }, [_c('section', {
    staticClass: "section section--intro"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/about/about-intro-image.jpg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "about-intro"
  }, [_c('div', {
    staticClass: "about-intro__col"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_c('span', {
    staticClass: "font-en"
  }, [_vm._v("SBA")]), _vm._v(" 국제유통센터 "), _c('br'), _c('span', {
    staticClass: "color-primary"
  }, [_c('span', {
    staticClass: "font-en"
  }, [_vm._v("B2B")]), _vm._v(" 매칭상담회 플랫폼")])])]), _c('div', {
    staticClass: "about-intro__col"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("서울어워드 상품과 SBA 국제유통센터에서 발굴한 바이어 간 매칭을 지원합니다.")]), _c('p', {
    staticClass: "txt"
  }, [_vm._v(" 해외로 수출할 만한 우수한 상품을 찾는 유통인들과 우수한 제품을 국내외 유통 및 수출할 수 있는 판로 개척이 필요한 중소기업을 위해 유통 채널이 입점된 B2B 매칭상담회 플랫폼입니다. ")])])])])]), _c('section', {
    staticClass: "section section--qna"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('ul', {
    staticClass: "about-qna"
  }, [_c('li', {
    staticClass: "about-qna__list"
  }, [_c('div', {
    staticClass: "about-qna__head"
  }, [_c('em', {
    staticClass: "badge"
  }, [_vm._v("Q1")]), _c('p', {
    staticClass: "tit"
  }, [_vm._v("계정 정보는 어떻게 확인할 수 있나요? ")])]), _c('div', {
    staticClass: "about-qna__body"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v(" 중소 제조기업 분들에게는 서울어워드 신청시 기재한 메일로 계정 정보를 전달드렸습니다. 메일을 확인하셔서 로그인후 마이페이지에서 정보 수정을 부탁드리겠습니다. ")])])]), _c('li', {
    staticClass: "about-qna__list"
  }, [_c('div', {
    staticClass: "about-qna__head"
  }, [_c('em', {
    staticClass: "badge"
  }, [_vm._v("Q2")]), _c('p', {
    staticClass: "tit"
  }, [_vm._v("매칭상담회 셀러로 참여하고 싶어요!")])]), _c('div', {
    staticClass: "about-qna__body"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v(" B2B 매칭상담회에는 SBA 국제유통센터에서 진행하는 ‘서울어워드’, ‘슈퍼루키’에 참여한 기업만 참여하실 수 있습니다. ")]), _c('a', {
    staticClass: "button button--round button--border-white",
    attrs: {
      "href": "https://smc.sba.kr/Pages/BusinessInfo/HiSeoulAward.aspx?p=0",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("서울어워드 신청 바로가기")])])])]), _c('li', {
    staticClass: "about-qna__list"
  }, [_c('div', {
    staticClass: "about-qna__head"
  }, [_c('em', {
    staticClass: "badge"
  }, [_vm._v("Q3")]), _c('p', {
    staticClass: "tit"
  }, [_vm._v("매칭상담회 바이어로 참여하고 싶어요!")])]), _c('div', {
    staticClass: "about-qna__body"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v(" 바이어로 참여를 희망하실 경우, 하단 링크를 통해 바이어 지원을 해주시면 검토 후 개별 연락을 드릴 예정입니다. ")]), _c('a', {
    staticClass: "button button--round button--border-white",
    attrs: {
      "href": "https://forms.gle/tRqixDVHd69aucU66",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("바이어 신청 바로가기")])])])])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }